exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReviewCard {\n  font-size: 16px;\n}\n.ReviewCard h5 {\n  font-weight: bold;\n  font-style: italic;\n  font-size: 16px;\n}\n.ReviewCard .PlatformIcon {\n  font-size: 40px;\n}\n.ReviewCard .ReviewCard__body .TextBlock {\n  display: inline-block;\n}\n.ReviewCard .RatingStars {\n  font-size: 21px;\n  display: inline-block;\n}\n", ""]);

// exports
